import React, { Component } from 'react';
import './Content.css';
import About from './Pages/About.js'
import Home from './Pages/Home.js'
import Woodwork from './Pages/Woodwork.js'
import Projects from './Pages/Projects.js'

class Content extends Component {
  render() {
    switch(this.props.mainState){
      case "about":
        return (
          <div className="content">
            <About />
          </div>
        );
      case "projects":
        return (
          <div className="content">
            <Projects />
          </div>
        );
      case "woodwork":
        return (
          <div className="content">
            <Woodwork />
          </div>
        );
      default:
        return (
          <div className="content">
            <Home />
          </div>
        );
    }
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/Content/Content.js